import { Component, OnInit ,Input,Output,EventEmitter } from '@angular/core';
import {CommonsService} from "@core/service/commons.service";

@Component({
  selector: 'app-ladder-quotation',
  templateUrl: './ladder-quotation.component.html',
  styles: []
})
export class LadderQuotationComponent implements OnInit {
  @Input() readonly;//是否只读
  @Input()ladderList;//列表数据
  @Input()ladderVisible;//modal框是否显示
  @Output() private modelOk = new EventEmitter();//点击确定按钮
  @Output() private modelCancel = new EventEmitter();//点击取消按钮
  ladderOk(){
    for(let i=0;i<this.ladderList.length;i++){
      if((this.ladderList[i].levelRate && !this.ladderList[i].price) || (!this.ladderList[i].levelRate && this.ladderList[i].price)){
        this.commonsService.showWarningMessage('commons.info.completeFull');
        return;
      }
    }
    this.modelOk.emit(this.ladderList);
  }
  ladderCancel(){
    this.modelCancel.emit();
  }
  constructor(private commonsService:CommonsService) { }

  ngOnInit() {
  }

}
